const CONST = {
  NO_RESULTS_CHECK_FILTERS: 'No hay resultados, revise los filtros por favor.',
  REFRESH: 'Refrescar',
  CLEAN_FILTERS: 'Limpiar Filtros',
  APPLY_FILTERS: 'Filtrar',
  ACCEPT: 'Aceptar',
  ROWS_PER_PAGE_ITEMS: [20, 30, 50, { title: 'Todos', value: -1 }],
  ROWS_PER_PAGE_TEXT: 'Filas por página.'
}

export default CONST
